import { useMount } from 'shared/hooks'

import { appConnector } from './singleton'

type AnyListener = () => Promise<void> | void

export function useAutomationEnded(listener: AnyListener) {
	useMount(() => {
		appConnector.eventHandlers.addAutomationEndedEventHandler(listener)

		return () => appConnector.eventHandlers.removeAutomationEndedEventHandlers()
	})
}
